module.exports = __webpack_public_path__ + "static/img/ewm.a90f6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ewm.png
// module id = 0r7s
// module chunks = 26